








import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { setStorage } from "@common/utils";
import Menu from "@/zh-website/src/components/website/Menu.vue";
import BottomFoot from "@/zh-website/src/components/website/BottomFoot.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
@Component({
  components: {
    Menu,
    BottomFoot,
    SideBar
  }
})
export default class Index extends Vue {}
